/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Outcome_Dialog_TitleInputs */

const en_task_outcome_dialog_title = /** @type {(inputs: Task_Outcome_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Task`)
};

const pt_br2_task_outcome_dialog_title = /** @type {(inputs: Task_Outcome_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir Atividade`)
};

/**
* | output |
* | --- |
* | "Complete Task" |
*
* @param {Task_Outcome_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_outcome_dialog_title = /** @type {((inputs?: Task_Outcome_Dialog_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Outcome_Dialog_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_outcome_dialog_title(inputs)
	return pt_br2_task_outcome_dialog_title(inputs)
});